export default function ServiceDetails() {
  const services = [
    {
      title: 'Respite Care',
      description: 'Caring for a loved one is rewarding but can be physically and emotionally demanding. Our respite care services give family caregivers the break they need to recharge, knowing their loved one is in capable, compassionate hands.',
      image: 'https://public.readdy.ai/ai/img_res/1a101dd2c95ebd361a175e91947f5afa.jpg',
      features: [
        'Flexible scheduling from a few hours to several days',
        'Experienced caregivers trained in senior care',
        'Medication reminders and health monitoring',
        'Engaging activities and companionship',
        'Peace of mind for family caregivers',
        'Emergency backup care available'
      ]
    },
    {
      title: 'Personal Care & Hygiene',
      description: 'Maintaining personal hygiene is essential for health, comfort, and dignity. Our caregivers provide sensitive, respectful assistance with daily personal care tasks, helping clients feel clean, comfortable, and confident.',
      image: 'https://readdy.ai/api/search-image?query=Compassionate%20caregiver%20assisting%20elderly%20person%20with%20personal%20care%20in%20bright%20clean%20bathroom%20environment%20showing%20dignity%20and%20respect%20with%20professional%20healthcare%20setting%20simple%20background&width=800&height=600&seq=personal-care-detail&orientation=landscape',
      features: [
        'Bathing and shower assistance',
        'Oral hygiene and denture care',
        'Dressing and grooming support',
        'Toileting and incontinence care',
        'Skin care and moisturizing',
        'Hair care and shaving assistance'
      ]
    },
    {
      title: 'Light Housekeeping',
      description: 'A clean, organized home contributes to safety, comfort, and well-being. Our light housekeeping services help maintain a tidy living environment, reducing fall risks and creating a pleasant space for daily activities.',
      image: 'https://readdy.ai/api/search-image?query=Professional%20caregiver%20doing%20light%20housekeeping%20in%20clean%20organized%20senior%20home%20interior%20with%20natural%20lighting%20showing%20tidy%20living%20space%20and%20comfortable%20environment%20simple%20clean%20background&width=800&height=600&seq=housekeeping-detail&orientation=landscape',
      features: [
        'Vacuuming and sweeping floors',
        'Dusting furniture and surfaces',
        'Kitchen cleaning and dish washing',
        'Bathroom sanitizing',
        'Laundry and linen changes',
        'Organizing and decluttering'
      ]
    },
    {
      title: 'Meal Preparation',
      description: 'Proper nutrition is vital for health and energy. Our caregivers prepare delicious, nutritious meals tailored to dietary needs, preferences, and restrictions, making mealtimes enjoyable and stress-free.',
      image: 'https://readdy.ai/api/search-image?query=Professional%20caregiver%20preparing%20healthy%20nutritious%20meal%20in%20modern%20kitchen%20with%20fresh%20ingredients%20and%20organized%20cooking%20space%20showing%20care%20and%20attention%20to%20dietary%20needs%20simple%20clean%20background&width=800&height=600&seq=meal-prep-detail&orientation=landscape',
      features: [
        'Customized meal planning',
        'Accommodation of dietary restrictions',
        'Grocery shopping assistance',
        'Fresh, home-cooked meals',
        'Proper food storage and safety',
        'Assistance with feeding if needed'
      ]
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="space-y-24">
          {services.map((service, index) => (
            <div
              key={index}
              className={`grid lg:grid-cols-2 gap-12 items-center ${
                index % 2 === 1 ? 'lg:flex-row-reverse' : ''
              }`}
            >
              <div className={`${index % 2 === 1 ? 'lg:order-2' : ''}`}>
                <div className="relative rounded-2xl overflow-hidden shadow-2xl h-96 w-full">
                  <img
                    src={service.image}
                    alt={service.title}
                    className="w-full h-full object-cover object-top"
                  />
                </div>
              </div>

              <div className={`space-y-6 ${index % 2 === 1 ? 'lg:order-1' : ''}`}>
                <h2 className="text-4xl font-bold text-[#5C4F8A]">{service.title}</h2>
                <p className="text-base text-gray-700 leading-relaxed">
                  {service.description}
                </p>
                <div className="space-y-3">
                  <h3 className="text-lg font-bold text-gray-900">What We Offer:</h3>
                  <ul className="space-y-2">
                    {service.features.map((feature, idx) => (
                      <li key={idx} className="flex items-start gap-3">
                        <i className="ri-checkbox-circle-fill text-orange-500 text-xl flex-shrink-0 w-6 h-6 flex items-center justify-center"></i>
                        <span className="text-sm text-gray-700">{feature}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}